// base.js
// Empty application placeholder

import React from 'react';
import { Paper, Typography } from '@mui/material';

export default function BaseApp() {
  return (
    <Paper elevation={4} sx={{ p: 3, maxWidth: 320, margin: 'auto' }}>
      <Typography variant="h6" align="center" gutterBottom>
        Application vide
      </Typography>
      <Typography variant="body1" align="center" color="textSecondary">
        Empty application
      </Typography>
    </Paper>
  );
}
